module.exports = __webpack_public_path__ + "img/icon-4.39887815.svg";